module.exports = __webpack_public_path__ + "static/media/247.230109c6.svg";